import {notificationConstants} from "../constants/notification.constants";
import {notificationService} from "../services/notification.service";

const getAll = () => {
    return dispatch => {
        dispatch({type: notificationConstants.GET_LIST_REQUEST});
        notificationService.getAll()
            .then(
                (list) => {
                    dispatch({type: notificationConstants.GET_LIST_SUCCESS, list});
                },
                (error) => {
                    dispatch({type: notificationConstants.GET_LIST_ERROR, error})
                }
            )
    }
};

const getUnRead = () => {
    return dispatch => {
        notificationService.getUnRead()
            .then(
                (list) => {
                    dispatch({type: notificationConstants.GET_LIST_UNREAD_SUCCESS, list});
                },
                (error) => {
                    dispatch({type: notificationConstants.GET_LIST_UNREAD_ERROR, error})
                }
            )
    }
}

const readById = (id) => {
    return dispatch => {
        notificationService.readById(id)
            .then(
                () => {
                    dispatch(getAll());
                    dispatch(getUnRead());
                }
            )
    }
}

const readByArrayIds = (arrayIds) => {
    return dispatch => {
        notificationService.readByArrayIds(arrayIds)
            .then(
                () => {
                    dispatch(getAll());
                    dispatch(getUnRead());
                }
            )
    }
}

export const notificationActions = {
    getAll,
    getUnRead,
    readById,
    readByArrayIds
}